import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";

export interface TextEditDialogData {
  title: string;
  prompt: string;
  data: string;
}

@Component({
  selector: "text-edit-dialog",
  styleUrls: ["./text-edit-dialog.component.html"],
  templateUrl: "./text-edit-dialog.component.html",
})
export class TextEditDialogComponent {
  public Result: DialogResult;
  public CurrentData: string;

  constructor(
    public dialogRef: MatDialogRef<TextEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TextEditDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
    this.CurrentData = data.data;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.CurrentData;
    this.dialogRef.close(this.Result);
  }
}
